import React, { Component } from 'react';
import "./epicImageGrid.css";

export default class extends Component {
  constructor(props) {
      super(props);
      this.state = {
          componentReady: 'ready'
      };
  }

  render() {
    return (
      <div className="epic-image-grid-container" style={{backgroundColor:this.props.backgroundColor}}>
        <div className={'row'}>
          <div className="small-12 medium-6">
            <div className="epic-image-grid-one">
              <img className="full-width background-image-fill hover-grow" src={"images/square.png"} style={{backgroundImage: `url(${ this.props.imageOne })`}} />
            </div>
          </div>
          <div className="small-12 medium-6">
            <div className="epic-image-grid-two row">
              <div className="full-width background-image-fill hover-grow" style={{backgroundImage: `url(${ this.props.imageTwo })`}} >
                <img className="full-width show-for-small" src={"images/rectangle.png"} />
              </div>
            </div>
          </div>
        </div>
        <div className="row epic-image-grid-container-bottom-row">
          <div className="small-12 medium-6">
            <img className="full-width background-image-fill" src={"images/rectangle.png"} style={{backgroundImage: `url(${ this.props.imageThree })`}} />
          </div>
          <div className="small-12 medium-6">
            <img className="full-width background-image-fit epic-image-grid-four" src={"images/square.png"} style={{backgroundImage: `url(${ this.props.imageFour })`}} />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/alpineComponents/epicImageGrid/index.js